import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  RerunVersionSelector,
  RerunVersionUnchanged,
} from "@/payroll/pay-breakdown/rerun-version-selector";
import type {
  AiScriptRerunVersionChoice,
  AiScriptRerunVersionInfo,
} from "@/payroll/pay-breakdown/types";
import { getAiScriptRerunState } from "@/payroll/pay-breakdown/utils";

interface RerunVersionChoicesProps {
  versionInfo: AiScriptRerunVersionInfo;
  isScopedRerun: boolean;
  scriptChoice: AiScriptRerunVersionChoice | null;
  rosterChoice: AiScriptRerunVersionChoice | null;
  setScriptChoice: (choice: AiScriptRerunVersionChoice) => void;
  setRosterChoice: (choice: AiScriptRerunVersionChoice) => void;
}

export const RerunVersionChoices = ({
  versionInfo,
  isScopedRerun,
  scriptChoice,
  rosterChoice,
  setScriptChoice,
  setRosterChoice,
}: RerunVersionChoicesProps) => {
  const { scriptDrift, rosterDrift, scriptVersion, rosterVersion } =
    getAiScriptRerunState(versionInfo);

  return (
    <Stack className="w-full" align="start" gap={4}>
      {scriptDrift && isScopedRerun ? (
        <Stack className="w-full" align="start" gap={1}>
          <RerunVersionUnchanged
            label="Script"
            version={versionInfo.runScriptVersion!}
          />
          <Text variant="caption" tone="muted">
            A section rerun must use the script from the current Grid. Rerun
            everything to use another script version.
          </Text>
        </Stack>
      ) : scriptDrift ? (
        <RerunVersionSelector
          label="Script"
          runVersion={versionInfo.runScriptVersion}
          currentVersion={versionInfo.currentScriptVersion}
          choice={scriptChoice}
          onChange={setScriptChoice}
        />
      ) : (
        scriptVersion != null && (
          <RerunVersionUnchanged label="Script" version={scriptVersion} />
        )
      )}
      {rosterDrift ? (
        <RerunVersionSelector
          label="Roster"
          runVersion={versionInfo.runRosterVersion}
          currentVersion={versionInfo.currentRosterVersion}
          choice={rosterChoice}
          onChange={setRosterChoice}
        />
      ) : (
        rosterVersion != null && (
          <RerunVersionUnchanged label="Roster" version={rosterVersion} />
        )
      )}
    </Stack>
  );
};
